module.exports = __webpack_public_path__ + "img/main_button_moresearch_down.de3638d0.png";